// - sessionStorage.setItem('its-debug-mode', true)
export const DEBUG_MODE_KEY = 'its-debug-mode';
export const IS_DEBUG_MODE = sessionStorage.getItem(DEBUG_MODE_KEY);

// - sessionStorage.setItem('its-dev-mode', true)
export const DEV_MODE_KEY = 'its-dev-mode';
export const IS_DEV_MODE = sessionStorage.getItem(DEV_MODE_KEY);

// - /checkout?its-override=X.X.X
export const OVERRIDE_MODE_KEY = 'its-override';
export const IS_OVERRIDE_MODE = new URLSearchParams(window.location.search).get(
  OVERRIDE_MODE_KEY,
);

export const IS_DEBUG_MODE_ENABLED = !!(IS_DEV_MODE || IS_DEBUG_MODE);

export const GLOBAL_STYLE_SHEET_ID = 'its-services-global-styles';

export const CSS_PATH = IS_DEV_MODE
  ? 'http://localhost:4000/dist/main.css'
  : window.itsServices.cssPath;

export const ON_CART_REFRESH_CONTENT_COMPLETED =
  'cart-refresh-content-completed';

export const WIDGET_MOUNT_ID = 'its-services';

const CART_LOADER_EL = document.querySelector(
  '[data-cart] .js-loadingOverlay-cart',
);

export const CART_LOADER = {
  show: () => CART_LOADER_EL?.setAttribute('data-its-loading', 'true'),
  hide: () => CART_LOADER_EL?.removeAttribute('data-its-loading'),
};

// 1gfd17pa = BBWheelsOnline.com
// hlov685lqm = WheelSetGo.com
export const PRODUCTION_STORE_HASH = ['1gfd17pa', 'hlov685lqm'];
